import { useCallback } from 'react';
import { UserResponseStatus } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import { Colors } from '../../styles/theme';

export const useResponseStatus = () => {
    const intl = useIntl();

    const getStatusColor = useCallback((status: UserResponseStatus | null): Colors => {
        switch (status) {
            case 'available':
            case 'visio':
            case 'onSpot':
            case 1:
                return 'green';
            case 'unknown':
                return 'yellow';
            case 'unavailable':
            case 0:
                return 'orange';
            default:
                return 'green';
        }
    }, []);

    const getStatusLabel = useCallback(
        (status: UserResponseStatus | null) => {
            switch (status) {
                case 1:
                case 'available':
                    return intl.formatMessage({ id: 'CALENDAR_Status_Available' });
                case 'visio':
                    return intl.formatMessage({ id: 'CALENDAR_Status_Visio' });
                case 'onSpot':
                    return intl.formatMessage({ id: 'CALENDAR_Status_OnSpot' });
                case 0:
                case 'unavailable':
                    return intl.formatMessage({ id: 'CALENDAR_Status_Unavailable' });
                case 'unknown':
                    return intl.formatMessage({ id: 'CALENDAR_Status_Unknown' });
                default:
                    return intl.formatMessage({ id: 'CALENDAR_Status_Available' });
            }
        },
        [intl],
    );

    return { getStatusColor, getStatusLabel };
};
